export enum EcoMenuKeys {
  Edit = 'edit',
  Preview = 'preview',
  Execute = 'execute',
  Export = 'export',
  DeleteEco = 'deleteEco',
  ViewEco = 'viewEco',
  ShowResults = 'showResults',
}
